import React, { useMemo } from "react";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";
import FilesActionGroup from "../../FilesActionGroup/FilesActionGroup.js";
import DownloadActionComponent from "../../FilesActionGroup/DownloadAction.js";
import CommentComponent from "../..//SideBar/Comment/CommentSideComponent.js";
import SideBarContentHolder from "../../SideBar/SideBarContentHolder.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { useSideBar } from "../../../../contexts/sideBarContext/sideBarContext.js";
import { useComments } from "../../../../contexts/commentsContext/commentsContext.js";
import GetTransformedDate from "../../../../utils/dateViewTransformer.tsx";
import GridItem from "../Grid/GridItem.js";
import { useInView } from "react-intersection-observer";
import { decode } from "html-entities";
import { useActionList } from "hooks/useActionList.js";
import useSelfRemovalLink from "hooks/useSelfRemovalLink.tsx";

const FeedItem = ({ itemId }) => {
  const { setSideBar } = useSideBar();
  const { getFilesData, getMailSecurity } = useMail();
  const { getTextByKey } = useContent();
  const { getFileCommentsList, getAllCommentsData } = useComments();
  const actionList = useActionList({
    defaultActionList: ["Comment", "Share"],
    security: getMailSecurity(),
  });

  const [ref, inView] = useInView({ triggerOnce: true });

  const commentsIdList = getFileCommentsList(itemId);

  const handleClick = () => {
    setSideBar(
      <SideBarContentHolder
        headerName={getTextByKey("sidebar-comment-header")}
        headerIcon={"comment"}
      >
        <CommentComponent itemId={itemId} />
      </SideBarContentHolder>,
      itemId
    );
  };

  const isSelfRemove = useSelfRemovalLink();

  return (
    <div className="feed-item" ref={ref}>
      <div className="feed-item-header">
        <span>&#x200E;{getFilesData()[itemId]?.Name}</span>
      </div>
      {inView ? (
        <>
          <GridItem itemId={itemId} inFeed={true} />
          {isSelfRemove ? null : (
            <div className="feed-item-footer">
              <FilesActionGroup {...{ actionList, itemId }} />
              {getMailSecurity()?.previewFiles ? null : (
                <DownloadActionComponent itemId={itemId} />
              )}
            </div>
          )}
        </>
      ) : null}
      <div className="feed-item-comments" onClick={handleClick}>
        {commentsIdList.map((commentId, i) => {
          if (i < 2) {
            const dateToShow =
              getAllCommentsData()[commentId].Updated ||
              getAllCommentsData()[commentId].Created;
            return (
              <div className="comment-component">
                <div className="comment-header">
                  <div
                    className="comment-user-avatar"
                    style={{
                      background: `url("${
                        getAllCommentsData()[commentId].UserAvatar
                      }"), center`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                  <div className="comment-user-name">
                    {getAllCommentsData()[commentId].UserName}
                  </div>
                  <div className="flex-spacer"></div>
                </div>
                <div className="comment-content">
                  {decode(getAllCommentsData()[commentId].Content)}
                </div>
                <div className="comment-date">
                  {getAllCommentsData()[commentId].Updated && (
                    <span className="info">
                      {getTextByKey("sidebar-comment-edited")}
                    </span>
                  )}
                  <GetTransformedDate date={dateToShow} fullView={true} />
                </div>
              </div>
            );
          } else {
            return null;
          }
        })}
        {commentsIdList.length > 2 ? (
          <div className="feed-item-comments-showmore">
            Show {commentsIdList.length - 2} more comment
            {commentsIdList.length === 3 ? "" : "s"}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default FeedItem;
